import axios from "axios";
import { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import Loader from "../../../components/Loader";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import AddPortfolioTabData from "./ProtofolioTabData";

const initialData = {
    property: [],
    name: "",
    description: ""
};

const EditPortfolioModal = ({ showModal, onClose, onCallApi, id, from }) => {
    const [config] = useAuth();
    const [error, setError] = useState();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState(initialData);
    const [disable, setDisable] = useState(false);

    const handleClose = () => {
        setFormData(initialData);
        onClose();
    };

    useEffect(() => {
        if (id && showModal) {
            setLoading(true);
            axios
                .get(`${BASE_URL}/portfolio-getbyid/${id}`, config)
                .then((res) => {
                    const data = res?.data?.data;
                    const properties = data?.portfolois?.map((item) => ({
                        id: item.id,
                        property_name: (
                            <>
                                {item.property?.property_name} <br />
                                {item.property?.street_address}, {item.property?.city}, {item.property?.state}
                            </>
                        ),
                    })) || [];
                    setFormData({
                        property: properties,
                        name: data?.name || "",
                        description: data?.description || ""
                    });
                })
                .catch((err) => {
                    if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                        NotificationManager.error(err.response?.data?.message);
                    }
                })
                .finally(() => setLoading(false));
        }
    }, [id, showModal]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setDisable(true);
        const values = {
            property: formData.property,
            name: formData.name,
            description: formData.description,
        };

        const dataToSend =
            from === "contact"
                ? { ...values, contact_id: id }
                : { ...values, company_id: id, contact_id: formData.contactId };

        axios
            .post(`${BASE_URL}/portfolio-edit/${id}`, dataToSend, config)
            .then((res) => {
                handleClose();
                onCallApi();
            })
            .catch((err) => {
                setError(err.response?.data?.errors);
                if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
                    NotificationManager.error(err.response?.data?.message);
                }
            })
            .finally(() => setDisable(false));
    };

    const handleChange = (value, name) => {
        setError({ ...error, [name]: "" });
        setFormData({ ...formData, [name]: value });
    };

    return (
        <Modal title={`Edit Closed`} desc={`Edit the Closed information.`} show={showModal} onClose={onClose}>
            {loading ? (
                <Loader />
            ) : (
                <AddPortfolioTabData
                    formData={formData}
                    error={error}
                    onSetFormData={(value) => {
                        setFormData(value);
                    }}
                    onSetError={(value) => setError(value)}
                    handleClose={handleClose}
                    showModal={showModal}
                    from={from}
                    id={id}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                    disable={disable}
                />
            )}
        </Modal>
    );
};

export default EditPortfolioModal;
